import { JobRun } from '@/type';
import api from '@/API';

export default {
  findRuns(jobIds: number[]): Promise<JobRun[]> {
    // VERY IMPORTANT to filter out invalid job IDs. Undefined, null, NaN, etc. values
    // can result in an API call with no jobIds[] which can lead to a full table scan
    // in the backend. Fixed in coreonlinemarketing/monitoring-bundle v0.4.2
    const validJobIds = jobIds.filter(id => typeof id === 'number' && !Number.isNaN(id));
    if (validJobIds.length === 0) return Promise.resolve([]);
    return api
      .get(
        'monitoring/job-runs',
        { params: { jobIds: validJobIds, onlyLatest: true } },
      )
      .then(response => response.data);
  },
};
